import { render } from "./ProductModelContent.vue?vue&type=template&id=8d00a4fc&scoped=true"
import script from "./ProductModelContent.vue?vue&type=script&lang=js"
export * from "./ProductModelContent.vue?vue&type=script&lang=js"

import "./ProductModelContent.vue?vue&type=style&index=0&id=8d00a4fc&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d00a4fc"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem});
